
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/basin",
      function () {
        return require("private-next-pages/basin.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/basin"])
      });
    }
  